import { useState } from 'react';
import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { getServices } from '../../../mocks/pretAPorter';

export default function ServicesSection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });
  const [activeService, setActiveService] = useState(0);

  return (
    <section ref={ref} className="w-full bg-white py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto" style={style}>
          <span className="font-sans text-brand-gray-400 text-[11px] tracking-[0.2em] uppercase font-medium">
            Servicios
          </span>
          <h2 className="font-serif text-brand-black text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.15] mt-4">
            Qué podemos
            <span className="italic text-brand-gray-300"> hacer por ti</span>
          </h2>
          <p className="font-sans text-brand-gray-500 text-[15px] leading-[1.8] mt-4">
            Precios orientativos. Solicita tu presupuesto gratuito sin compromiso.
          </p>
        </div>

        {/* Service Tabs */}
        <div
          className="mt-12 flex justify-center gap-3"
          style={isVisible ? {
            opacity: 1,
            transform: 'translateY(0px)',
            transition: 'opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 150ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 150ms',
          } : {
            opacity: 0,
            transform: 'translateY(20px)',
            transition: 'opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 150ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 150ms',
            willChange: 'opacity, transform',
          }}
        >
          {getServices().map((service, index) => (
            <button
              key={service.id}
              onClick={() => setActiveService(index)}
              className={`flex items-center gap-2 font-sans text-sm px-6 py-3 rounded-full transition-all duration-300 whitespace-nowrap ${
                index === activeService
                  ? 'bg-brand-black text-white'
                  : 'bg-brand-gray-50 text-brand-gray-600 hover:text-brand-black border border-brand-gray-200'
              }`}
            >
              <i className={`${service.icon}`} />
              {service.category}
            </button>
          ))}
        </div>

        {/* Service Table */}
        <div
          className="mt-10 max-w-3xl mx-auto"
          style={isVisible ? {
            opacity: 1,
            transform: 'translateY(0px)',
            transition: 'opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 300ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 300ms',
          } : {
            opacity: 0,
            transform: 'translateY(16px)',
            transition: 'opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 300ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 300ms',
            willChange: 'opacity, transform',
          }}
        >
          <div className="bg-brand-gray-50 rounded-[24px] overflow-hidden">
            <div className="hidden md:grid grid-cols-[1fr_120px_120px] px-8 py-4 border-b border-brand-gray-200">
              <span className="font-sans text-brand-gray-400 text-xs tracking-wider uppercase font-medium">
                Servicio
              </span>
              <span className="font-sans text-brand-gray-400 text-xs tracking-wider uppercase font-medium text-center">
                Desde
              </span>
              <span className="font-sans text-brand-gray-400 text-xs tracking-wider uppercase font-medium text-center">
                Tiempo
              </span>
            </div>

            <div className="divide-y divide-brand-gray-200">
              {getServices()[activeService].items.map((item) => (
                <div
                  key={item.name}
                  className="grid grid-cols-1 md:grid-cols-[1fr_120px_120px] px-6 md:px-8 py-5 items-center hover:bg-white/50 transition-colors"
                >
                  <div>
                    <span className="font-sans text-brand-black text-[15px] font-medium">
                      {item.name}
                    </span>
                    <div className="md:hidden flex gap-4 mt-1">
                      <span className="font-sans text-brand-gray-500 text-sm">{item.price}</span>
                      <span className="font-sans text-brand-gray-400 text-sm">{item.duration}</span>
                    </div>
                  </div>
                  <span className="hidden md:block font-sans text-brand-black text-sm font-medium text-center">
                    {item.price}
                  </span>
                  <span className="hidden md:block font-sans text-brand-gray-500 text-sm text-center">
                    {item.duration}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <p className="font-sans text-brand-gray-400 text-xs mt-4 text-center leading-relaxed">
            Los precios son orientativos y pueden variar según la complejidad del trabajo.
            Solicita tu presupuesto personalizado gratuito.
          </p>
        </div>
      </div>
    </section>
  );
}